import EspecieAnimalModel from "../../models/paciente/especieAnimalModel";
import { iServiceCached } from "../base/iServiceCached";

class EspecieAnimalService extends iServiceCached<EspecieAnimalModel> {
    constructor() {
        super("EspecieAnimal");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.descricao,
            franquiaId: p.franquiaId,
        }));
    }
}

export default new EspecieAnimalService();
